import React from 'react';
import {Box, Typography} from '@mui/material';
import {IPointTemplatesSingleVoyage} from "@containers/singleVoyage/pointTemplates/types";
import {formatDistancePointTemplate} from "@containers/singleVoyage/pointTemplates/helpers/formatDistance";
import {sx} from './sx'

interface IProps {
	pointTemplate: IPointTemplatesSingleVoyage
	distance: number | null
}

/** two-line row: name on top, then address, radius, type and distance from the last stop */
const PointTemplateOptionRow = ({pointTemplate, distance}: IProps) => {

	const meta = [
		pointTemplate.address,
		`${pointTemplate.radius} м`,
		pointTemplate.type === 'RFID' ? 'RFID' : null,
	].filter(Boolean).join(' · ')

	return (
		<Box sx={sx.root}>
			<Typography sx={sx.name}>
				{pointTemplate.name}
			</Typography>

			<Typography sx={sx.meta}>
				{distance !== null && <Box
					component={'span'}
					sx={sx.distance}
				>
					{formatDistancePointTemplate(distance)}
					{' · '}
				</Box>}
				{meta}
			</Typography>
		</Box>
	);
};

export default PointTemplateOptionRow;
